import { Component } from "react";
import "../../../styles/css/dashboard.scss";
import "../../../App.css";
import { appContext } from "../../../AppContext";
import { IUserDetails } from "../../../Providers.LocalStorage/Models";
import { IUserRights } from "../../../Providers.Api/Models.UserApi";
import { RouteComponentProps } from "react-router-dom";
import { rights } from "../../../Common/RightsManager";

class Home extends Component<RouteComponentProps>
{
    private labels = appContext().labels;
    private appState = appContext().state;
    private local = appContext().localStorageProvider;

    constructor(props: RouteComponentProps)
    {
        super(props);
        this.authCheck();
    }

    public authCheck(): void
    {
        const token = this.local.getToken();
        if (!token)
        {
            this.pushHistory("/login");
        }
    }

    public componentDidMount() 
    {
        this.redirect();
    }

    private redirect(): void
    {
        if (rights.FLEX.has())
        {
            this.pushHistory("/flex-home/");
        }
        else if (rights.ONELENS360.has())
        {
            this.pushHistory("/operational-services-home/");
        }
        else if (rights.ADMINPORTAL.has())
        {
            this.pushHistory(`/booking-policies/${this.appState.buildingId}`);
        }
        else
        {
            this.pushHistory("/access-denied");
        }
    }

    private pushHistory(url: string): void
    {
        this.props.history.replace(url);
    }

    public render(): JSX.Element
    {
        return (
            <div>
                <div className="redirectContainer">
                    <div className="title">{this.labels.HubLabelRedirectionStatus}</div>
                    <div className="subtitle">{this.labels.HubLabelRedirectionSubtitle_part_1} <span id="countdown"></span></div>
                </div>
            </div>
        );
    }
}

export default Home;
